import {
  Component,
  Input, ViewEncapsulation, inject, ViewChild, ViewContainerRef,
  ChangeDetectorRef
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { KENDO_BUTTON, KENDO_BUTTONS } from '@progress/kendo-angular-buttons';
import { KENDO_GRID, GridSize, GridComponent } from '@progress/kendo-angular-grid';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { KENDO_BREADCRUMB } from '@progress/kendo-angular-navigation';
import { saveIcon, editToolsIcon, plusIcon, uploadIcon, minusIcon } from '@progress/kendo-svg-icons';

import { LayoutModule } from "@progress/kendo-angular-layout";
import { InputsModule, KENDO_INPUTS, TextBoxComponent } from '@progress/kendo-angular-inputs';

import { LabelModule } from '@progress/kendo-angular-label';
import { KENDO_DROPDOWNS } from "@progress/kendo-angular-dropdowns";
import {
  FormControl, FormsModule, FormBuilder, FormGroup, ReactiveFormsModule, Validators

} from '@angular/forms';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { PortalObjectsService } from '../../../_services/portal-objects.service';
import { process } from '@progress/kendo-data-query';

import { SheetDescriptor, CellDefaultStyle, SheetRow, SpreadsheetMainMenuItem, SpreadsheetChangeEvent, DocumentDescriptor, SpreadsheetExcelExportEvent, SpreadsheetComponent, KENDO_SPREADSHEET, SpreadsheetBackColorComponent, SpreadsheetForeColorComponent, SpreadsheetExcelImportEvent } from "@progress/kendo-angular-spreadsheet";
import { DialogRef, DialogService, DialogsModule, DialogResult, WindowModule, KENDO_DIALOGS } from '@progress/kendo-angular-dialog';
import { SVGIcon, xIcon, gearIcon, fileExcelIcon, commentIcon, changeManuallyIcon, copyIcon, questionCircleIcon } from '@progress/kendo-svg-icons';
import { Companies, Users, UserTypeItem, usersDefault, CompaniesItem, emptyUsers, companiesDefault, UserAccessDetailsDTO, PortalAccess } from '../../../_models/admin';
import { PortalAdminService } from '../../../_services/portal-admin.service';
import {
  KENDO_NOTIFICATION,
  NotificationService
} from "@progress/kendo-angular-notification";
import { elementAt } from 'rxjs';
import { ScrollRequest } from '@progress/kendo-angular-treelist';
import { WindowRef, WindowService } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-users',
  standalone: true,
  imports: [KENDO_SVGICON, KENDO_BUTTON, KENDO_GRID, KENDO_BREADCRUMB, KENDO_NOTIFICATION, KENDO_DROPDOWNS, KENDO_SPREADSHEET,
    DialogsModule, WindowModule, KENDO_DIALOGS, KENDO_BUTTONS, KENDO_INPUTS,
    LayoutModule, CommonModule, DropDownListModule, InputsModule, LabelModule, FormsModule, ReactiveFormsModule
  ],
  templateUrl: './users.component.html',
  styleUrl: './users.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class UsersComponent {
  adminUsers: Users[] = [];
  adminUser!: Users;
  displayUsers: Users[] = [];
  selection: any[] = [];
  adminCompanies: Companies[] = [];
  companiesLoading: boolean = false;
  usersLoading: boolean = false;

  buttonshidden: boolean = false;
  addbuttonstate: boolean = false;
  removebuttonstate: boolean = true;
  savebuttonstate: boolean = true;
  uploadbuttonstate: boolean = false;
  readonly: boolean = false;
  focusOnUser: boolean = false;
  searchTerm: string = '';
  selectedRowItem: any[] = [];
  pageSize: number = 30;
  excelSVG: SVGIcon = fileExcelIcon;
  selectedUser: Users = emptyUsers();
  showWindow: boolean = false;
  userAccessDetailsList: UserAccessDetailsDTO[] = [];
  expandedPanel: number | null = null;
  loadingAccessDetails = false;
  showErrorDialog: boolean = false;
  errorMessage: string = '';
  resize = true;
  windowTop = 40; // Adjust as needed
  windowLeft = (window.innerWidth - 750) / 2; // 600 is the window width



  public iconNames: SVGIcon[] = [plusIcon, xIcon, saveIcon, uploadIcon, gearIcon, editToolsIcon, copyIcon, changeManuallyIcon, questionCircleIcon, minusIcon];

  public smallSize: GridSize = 'small';

  @ViewChild('grid') grid!: GridComponent;
  errorWindow = false;
  title = '';
  content = '';
  public form: FormGroup = new FormGroup({
    id: new FormControl(),
    firstname: new FormControl(),
    lastname: new FormControl(),

    email: new FormControl(),
    usertype: new FormControl(),
    created: new FormControl(),
    createdBy: new FormControl(),
    remarks: new FormControl(),
    company: new FormControl(),
    enabled: new FormControl(true),

  });

  listItems: Array<UserTypeItem> = [
    { text: "Admin", value: 'A' },
    { text: "Employee", value: 'E' },
    { text: "Supplier", value: 'S' },
    { text: "Subcontractor", value: 'X' },
  ];
  companiesItems: CompaniesItem[] = [];
  initialFormValues!: Users;

  selectedItem: UserTypeItem = usersDefault();
  selectedCompanyItem: CompaniesItem = companiesDefault();
  selectedUserType!: UserTypeItem;

  constructor(private windowService: WindowService,
    private portalObjectService: PortalObjectsService,
    private portalAdminService: PortalAdminService,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef
  ) { }
  ngOnInit(): void {
    this.getAdminUsers();
    if (this.adminCompanies.length == 0) {
      this.getAdminCompanies();
    }
    this.buildform();
  }

  getAdminUsers() {
    this.usersLoading = true;
    this.adminUsers = [];
    this.form.reset();

    this.portalAdminService.getUsers().subscribe({
      next: (result) => {
        this.adminUsers = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        this.showError(JSON.stringify(error.message));
        this.usersLoading = false;
      },
      complete: () => {
        this.displayUsers = this.adminUsers;
        this.usersLoading = false;
        this.selection = this.selectedRowItem;
        this.form.disable();
        if (this.focusOnUser) {
          this.form.reset();
          this.form.enable();
          const id = this.listItems.findIndex((i) => i.value == this.changedUser.usertype);
          const companyid = this.companiesItems.findIndex((x) => x.value === this.changedUser.companyId);
          this.form = this.formBuilder.group({
            id: this.changedUser.id,
            firstname: [this.changedUser.firstname, [Validators.required, Validators.minLength(1)]],
            lastname: [this.changedUser.lastname, [Validators.required, Validators.minLength(2)]],
            email: [this.changedUser.email, Validators.email],
            usertype: this.listItems[id],
            created: this.changedUser.created,
            createdBy: this.changedUser.createdBy,
            remarks: this.changedUser.remarks ? this.changedUser.remarks : '',
            company: this.companiesItems[companyid],
            enabled: this.changedUser.enabled === 'T' ? true : false,
          });
          this.selectedUserType = this.listItems[id];
          this.selectedCompanyItem = this.companiesItems[companyid];
          this.initialFormValues = this.form.value;
          this.readonly = false;
          this.buttonhandle('Click');
          this.uploadbuttonstate = false;
        }
      }
    });
  }

  ngAfterViewChecked() {
    if (this.focusOnUser && this.grid.view.length > 0) {
      const rowIndex = this.displayUsers.findIndex(user => user.email == this.selectedRowItem[0]);
      this.scrollTo(rowIndex - 1);
    }
  }

  scrollTo(rowIndex: number) {
    this.focusOnUser = false;
    let request: ScrollRequest = { row: rowIndex };
    this.grid.scrollTo(request);
  }

  public onFilter(inputValue: string): void {
    this.searchTerm = inputValue;
    this.form.reset();
    this.selection = [];
    this.form.disable();
    this.buttonhandle('Filter');
    this.displayUsers = process(this.adminUsers, {
      filter: {
        logic: 'or',
        filters: [
          {
            field: 'firstname',
            operator: 'contains',
            value: inputValue,
          },
          {
            field: 'lastname',
            operator: 'contains',
            value: inputValue,
          },
          {
            field: 'email',
            operator: 'contains',
            value: inputValue,
          },
        ],
      },
    }).data;
  }

  buildform() {
    this.form.enable();
    this.form = this.formBuilder.group({
      id: null,
      firstname: ['', [Validators.required, Validators.minLength(3)]],
      lastname: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      usertype: this.selectedItem,
      created: null,
      createdBy: null,
      remarks: null,
      company: this.selectedCompanyItem,
      enabled: true,


    });
    this.form.disable();
  }


  @Input() item = '';
  @ViewChild('firstnametext') firstnametext!: TextBoxComponent;
  onAddButtonClick() {
    this.buildform();
    this.form.enable();
    this.selection = [];
    this.buttonhandle('Add');
    this.initialFormValues = this.form.value;
    this.changedUser = emptyUsers();
    this.selectedCompanyItem = companiesDefault();
    this.selectedItem = usersDefault();
    this.changedUser.enabled = 'T';
    setTimeout(() => {
      this.firstnametext.focus();

    }, 100);


  }

  onRemoveButtonClick() {
    this.selectedRowItem = [];
    this.removebuttonstate = true;
    const popupErrorMessages = [
      'Cannot delete user: it is currently in use by one or more orders.'
    ];

    this.portalAdminService.deleteUsers(this.form.get('id')?.value).subscribe({
      next: (result) => {
        this.adminUser = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        //this.showError(JSON.stringify(error.message));

        const backendMessage = error?.error?.message || 'An unexpected error occurred.';
        if (popupErrorMessages.includes(backendMessage)) {
          this.errorMessage = backendMessage;
          this.showErrorDialog = true;
          this.cdr.markForCheck();
        } else {
          this.showErrorDialog = false;
          this.showError(backendMessage); // Show as red error
        }
        this.companiesLoading = false;
      },
      complete: () => {
        this.selection = [];
        this.getAdminUsers();
      }
    });
  }
  @ViewChild("appendTo", { read: ViewContainerRef, static: false })
  public appendTo!: ViewContainerRef;
  public showError(value: string): void {
    this.notificationService.show({
      content: value,

      hideAfter: 10000,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "slide", duration: 400 },
      type: { style: "error", icon: true },
    });
  }
  public success(value: string): void {
    this.notificationService.show({
      content: value,

      hideAfter: 3000,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "slide", duration: 400 },
      type: { style: "success", icon: true },
    });
  }

  userdata: Users = emptyUsers();

  userData(): Users {
    this.userdata.id = this.form.value.id;
    this.userdata.email = this.form.value.email.toLowerCase();
    this.userdata.firstname = this.form.value.firstname;
    this.userdata.lastname = this.form.value.lastname;
    this.userdata.remarks = this.form.value.remarks ?? '';
    this.userdata.companyId = this.form.value.company.value;
    this.userdata.companyName = this.form.value.company.text;
    this.userdata.usertype = this.form.value.usertype.value;
    this.userdata.createdBy = this.form.value.createdBy;
    this.userdata.created = this.form.value.created;
    if (this.form.value.enabled) {
      this.userdata.enabled = 'T';
    } else {
      this.userdata.enabled = 'F';
    }
    return this.userdata;
  }

  onSaveButtonClick() {



    this.selectedRowItem = [];
    this.buttonhandle('Save');
    if (this.changedUser.id == null) {
      this.portalAdminService.addUsers(this.changedUser).subscribe({
        next: (result) => {
          this.adminUser = result;
          this.changedUser = this.adminUser;
          this.focusOnUser = true;
          this.cdr.markForCheck();
        },
        error: (error) => {
          this.showError(JSON.stringify(error.message));
          this.companiesLoading = false;
        },
        complete: () => {
          this.selectedRowItem = [this.adminUser.email];
          this.displayUsers = [];
          this.getAdminUsers();
        }
      });
    } else {
      this.portalAdminService.updateUsers(this.changedUser.id, this.changedUser).subscribe({
        next: (result) => {
          this.adminUser = result;
          this.focusOnUser = true;
          this.cdr.markForCheck();
        },
        error: (error) => {
          console.log('Error :' + JSON.stringify(error.message))
          this.showError(JSON.stringify(error.message));
          this.companiesLoading = false;
        },
        complete: () => {
          this.selectedRowItem = [this.adminUser.email];
          this.displayUsers = [];
          this.getAdminUsers();
        }
      });
    }
  }


  buttonhandle(action: string) {
    this.addbuttonstate = true;
    this.removebuttonstate = true;
    this.savebuttonstate = true;

    if (action === 'Click') {
      this.addbuttonstate = false;
      this.removebuttonstate = false;
      this.uploadbuttonstate = false;
    }

    if (action === 'Filter') {
      this.addbuttonstate = false;
    }

    if (action === 'Save') {
      this.addbuttonstate = false;

    }

    if (action = 'Upload') {
      this.uploadbuttonstate = true;
    }

  }


  changedUser: Users = emptyUsers();

  onCellClick(event: any) {
    console.log("event", event)
    this.populateUserForm(event.dataItem);
  }

  populateUserForm(dataItem: Users) {
    this.form.reset();
    this.form.enable();

    const id = this.listItems.findIndex((i) => i.value == dataItem.usertype);
    const companyid = this.companiesItems.findIndex((x) => x.value === dataItem.companyId);
    let remark = dataItem.remarks;

    //this.selectedItem=this.listItems[event.dataItem.usertype];
    //this.changedUser.id=event.dataItem.id;
    this.changedUser.id = dataItem.id;
    this.changedUser.companyName = this.companiesItems[companyid].text;
    this.changedUser.companyId = this.companiesItems[companyid].value;
    this.changedUser.usertype = this.listItems[id].value;
    this.changedUser.firstname = dataItem.firstname;
    this.changedUser.lastname = dataItem.lastname;
    this.changedUser.email = dataItem.email;
    this.changedUser.remarks = dataItem.remarks;




    this.changedUser.created = dataItem.created;
    this.changedUser.createdBy = dataItem.createdBy;

    if (remark === null) {
      remark = '';
    }

    let enabled = true;
    if (dataItem.enabled === 'F') {
      this.changedUser.enabled = 'F'
      enabled = false;
    }
    else {
      this.changedUser.enabled = 'T';
    }
    this.form = this.formBuilder.group({
      id: dataItem.id,
      firstname: [dataItem.firstname, [Validators.required, Validators.minLength(1)]],
      lastname: [dataItem.lastname, [Validators.required, Validators.minLength(2)]],
      email: [dataItem.email, Validators.email],
      usertype: this.listItems[id],
      created: dataItem.created,
      createdBy: dataItem.createdBy,
      remarks: remark,
      company: this.companiesItems[companyid],
      enabled: enabled,


    });


    this.selectedUserType = this.listItems[id];
    this.selectedCompanyItem = this.companiesItems[companyid];



    this.initialFormValues = this.form.value;
    this.readonly = false;
    this.buttonhandle('Click');
    this.uploadbuttonstate = false;
  }

  valueChange(event: string, type: string) {
    console.log(event);
    if (type === 'firstname') {
      this.changedUser.firstname = event.trim();
    }
    if (type === 'lastname') {
      this.changedUser.lastname = event.trim();
    }
    if (type === 'email') {
      this.changedUser.email = event.trim().toLowerCase();
      this.mailChange();
    }
    if (type === 'remarks') {
      this.changedUser.remarks = event.trim();
      if (this.changedUser.remarks.length == 0) {
        this.changedUser.remarks = null;
      }
    }

    // if(['firstname','lastname','remarks'].includes(type)){

    // }
    this.formHasChanged();
  }




  usertypeChange(event: any) {

    //   this.changedUser.usertype = event.text;
    const id = this.listItems.findIndex((i) => i.text == event.text);
    this.changedUser.usertype = this.listItems[id].value;
    // if (this.selectedUserType != event) {
    //   this.savebuttonstate = false;
    // }
    this.formHasChanged();

  }

  companyChange(event: any) {
    this.changedUser.companyName = event.text;
    this.changedUser.companyId = event.text;
    const companyid = this.companiesItems.findIndex((x) => x.text === event.text);
    this.changedUser.companyId = this.companiesItems[companyid].value;
    // if (this.selectedCompanyItem != event) {
    //   this.savebuttonstate = false;
    // }
    this.formHasChanged();
  }

  UserEnabledChange(event: any) {
    this.form.patchValue({
      enabled: event.srcElement.checked
    });
    console.log(event)
    if (event.srcElement.checked) {
      this.changedUser.enabled = 'T'
    }
    else {
      this.changedUser.enabled = 'F'

    }
    this.formHasChanged();
  }

  mailCheck: boolean = false;
  emailFormat(email: string): boolean {
    const emailRegex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;

    return emailRegex.test(email);
  }

  mailChange() {
    this.mailCheck = false;


    const emailControl = this.form.get('email');


    if (emailControl?.valid) {
      if (this.changedUser.id != null) {
        let i = this.adminUsers.findIndex((x) => x.id === this.changedUser.id);
        if (this.adminUsers[i].email.toUpperCase() !== this.changedUser.email.toUpperCase()) {
          let x = this.adminUsers.findIndex((x) => x.email.toUpperCase() === this.changedUser.email.toUpperCase());
          if (x == -1) {
            this.mailCheck = true;
            // console.log('Valid Mail');
          }
          // else {
          //   this.mailCheck = false;
          // }
        }
        // else{
        //   if(this.adminUsers[i].email.toUpperCase()===this.changedUser.email.toUpperCase()){
        //    this.mailCheck = true; 
        //   }
        // }

        //console.log('Adjuste Mail ' + this.adminUsers[i].email);
      } else {
        /*check against loaded emails*/
        let x = this.adminUsers.findIndex((x) => x.email.toUpperCase() === this.changedUser.email.toUpperCase());
        if (x == -1) {
          this.mailCheck = true;
          // console.log('Valid Mail');
        }
      }

      //   this.mailCheck = true;

    }
    else {
      this.mailCheck = false;
    }
  }

  formHasChanged() {
    this.savebuttonstate = true;

    if (this.changedUser.firstname !== '' && this.changedUser.lastname !== ''
      && this.changedUser.usertype !== ''
      && this.changedUser.companyName !== '') {
      if (this.mailCheck) {
        this.savebuttonstate = false;
      } else {

        if (this.changedUser.id != null) {
          console.log(this.changedUser)
          let i = this.adminUsers.findIndex((x) => x.id === this.changedUser.id)
          console.log(this.adminUsers[i])
          if (JSON.stringify(this.adminUsers[i]) !== JSON.stringify(this.changedUser)) {
            if (this.emailFormat(this.changedUser.email)) {
              this.savebuttonstate = false;
            }
            // this.mailChange();
            // if(this.mailCheck){
            //   this.savebuttonstate=false;
            // }

          }
          // } else {
          //   console.log(this.changedUser);
          //   if (this.mailCheck) {
          //     this.savebuttonstate = false;
          //   }
        }

      }
    }


    //return true;

  }



  getAdminCompanies() {
    this.companiesLoading = true;
    this.adminCompanies = [];


    this.portalAdminService.getCompanies().subscribe({
      next: (result) => {
        this.adminCompanies = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        this.showError(JSON.stringify(error.message));
        this.companiesLoading = false;
      },
      complete: () => {
        for (let i = 0; i < this.adminCompanies.length; i++) {
          //  const comp =(this.adminCompanies[i].companyName,this.adminCompanies[i].companyId);
          // this.companyitem.text =this.adminCompanies[i].companyName;
          //     this.companyitem.value=this.adminCompanies[i].companyId;
          const data =
            { text: this.adminCompanies[i].companyName+" ("+this.adminCompanies[i].recipientCode+")", value: this.adminCompanies[i].companyId };
          this.companiesItems.push(data);
        }
        this.companiesLoading = false;
        //console.log(JSON.stringify(this.adminCompanies));
      }
    });
  }

  // EXCEL input

  public items: SpreadsheetMainMenuItem[] = [{ id: "file", active: true }];
  openedexcelwindow: boolean = false;
  @ViewChild('spreadsheet') spreadsheet1!: SpreadsheetComponent;
  windowTitle: string = 'Portal User(s) Load';
  

  private readonly defaultExceldata: SheetDescriptor[] = [
    {
      name: "Users",
      rows: [
        {
          cells: [
            { value: "Email", fontSize: 14, background: "rgb(24, 37, 170)", color: "rgb(255,255,255)", bold: true, enable: false },
            { value: "First Name", fontSize: 14, background: "rgb(24, 37, 170)", color: "rgb(255,255,255)", bold: true, enable: false },
            { value: "Last Name", fontSize: 14, background: "rgb(24, 37, 170)", color: "rgb(255,255,255)", bold: true, enable: false },
            { value: "Usertype", fontSize: 14, background: "rgb(24, 37, 170)", color: "rgb(255,255,255)", bold: true, enable: false },
            { value: "Company", fontSize: 14, background: "rgb(24, 37, 170)", color: "rgb(255,255,255)", bold: true, enable: false },
            { value: "Remarks", fontSize: 14, background: "rgb(24, 37, 170)", color: "rgb(255,255,255)", bold: true, enable: false }
          ]
        },
        {
          cells: [
            { value: "John.Doe@BlaBla.com" },
            { value: "John" },
            { value: "Doe" },
            { value: "S" },
            { value: "McDermott" },
            { value: "-" }
          ]
        }
      ],
      columns: [
        { index: 0, width: 180 },
        { index: 1, width: 120 },
        { index: 2, width: 120 },
        { index: 3, width: 65 },
        { index: 4, width: 140 }
      ]
    }
  ];

// This is what you bind to the Spreadsheet
exceldata: SheetDescriptor[] = this.cloneSheets(this.defaultExceldata);

private cloneSheets(data: SheetDescriptor[]): SheetDescriptor[] {
  // deep clone so changes don't mutate the default template
  return JSON.parse(JSON.stringify(data));
}

private importWaitTimer: any = null;
private importToken = 0;

onImport(e: any): void {
  const widget = e.sender;
  if (!widget) return;

  if (this.importWaitTimer) {
    clearTimeout(this.importWaitTimer);
    this.importWaitTimer = null;
  }

  const token = ++this.importToken;

  this.waitUntilStable(widget, token);
}

private waitUntilStable(widget: any, token: number): void {
  let lastSig = "";
  let stableCount = 0;
  const requiredStableTicks = 6; // 6 * 100ms = ~600ms stability
  const intervalMs = 0;
  const maxTries = 120; // 12 seconds max
  let tries = 0;

  const tick = () => {
    if (token !== this.importToken) return; // newer import started

    const json = widget.toJSON();
    const sheets = json?.sheets ?? [];
    const rows = sheets?.[0]?.rows ?? [];

    // Must have actual imported rows first
    if (sheets.length === 0 || rows.length === 0) {
      tries++;
      if (tries >= maxTries) {
        console.warn("Import did not produce rows in time.");
        this.importWaitTimer = null;
        return;
      }
      this.importWaitTimer = setTimeout(tick, intervalMs);
      return;
    }

    const sig = this.signatureForColumnA(rows, 25); // sample first 25 rows

    if (sig === lastSig) {
      stableCount++;
    } else {
      stableCount = 0;
      lastSig = sig;
    }

    // If stable for some ticks, import is "done"
    if (stableCount >= requiredStableTicks) {
      console.log("✅ Import stable. Applying lowercase...");
      
      this.lowercaseEmailColumn_UI(widget);
      const updated = widget.toJSON();
      this.exceldata = updated?.sheets ?? [];
      console.log("this.exceldata",this.exceldata)
      this.importWaitTimer = null;
      return;
    }

    tries++;
    if (tries >= maxTries) {
      console.warn("Import never became stable. Try increasing maxTries or requiredStableTicks.");
      this.importWaitTimer = null;
      return;
    }

    this.importWaitTimer = setTimeout(tick, intervalMs);
  };

  tick();
}

private signatureForColumnA(rows: any[], maxRows: number): string {
  const take = Math.min(rows.length, maxRows);
  const parts: string[] = [String(rows.length)];

  for (let i = 0; i < take; i++) {
    const cellA = rows[i]?.cells?.[0]; // column A in JSON is index 0
    const v = cellA?.value;
    parts.push(typeof v === "string" ? v : (v ?? "").toString());
  }
  return parts.join("|");
}

  
private lowercaseEmailColumn_UI(widget: any): void {
  
  const sheet = widget.activeSheet();
  const emailCol = 0; // 2nd column (B) - 1-based

  const json = widget.toJSON();
  const rows = json?.sheets?.[0]?.rows || [];
  console.log("rows",rows)
  if (!rows.length) return;

  // Assume row 1 is header, start at row 2
  for (let r0 = 0; r0 < rows.length; r0++) {
    const rowIndex1Based = r0 + 1;

    const cell = sheet.range(rowIndex1Based, emailCol);
    const v = cell.value();
    
    if (typeof v === 'string' && v.trim() !== '') {
      cell.value(v.toLowerCase());
      console.log("cell.value()",cell.value())
    }
  }

}



  private dialogs: DialogRef[] = [];
  onExcelClick() {
    this.exceldata = this.cloneSheets(this.defaultExceldata);
    this.buttonhandle('Upload');
    this.openedexcelwindow = true;
    this.uploadbuttonstate = true;
    this.addbuttonstate = true;

  }

  closeExcelWindow() {
      // stop any pending import wait
    if (this.importWaitTimer) {
      clearTimeout(this.importWaitTimer);
      this.importWaitTimer = null;
    }
    this.importToken++; // invalidate in-flight polling loops
    this.openedexcelwindow = false;
    this.uploadbuttonstate = false;
    this.addbuttonstate = false;
    this.dialogs = [];
    this.exceldata = this.cloneSheets(this.defaultExceldata);
    


  }

  public rowCallback = (context: { dataItem: any, index: number }): string => {
    return context.dataItem.enabled === 'F' ? 'disabled-row' : '';
  };

  mySelection: number[] = [1];

  openedExcelwindow() {
    this.openedexcelwindow = true;
    setTimeout(() => {
      this.spreadsheet1.onMenuItemSelect("file");
    });
  }
  t!: SpreadsheetBackColorComponent;

  sheettrow!: SheetRow;
  cellStyle: CellDefaultStyle = {
    bold: true,
    underline: true,
    fontSize: 20,
    color: "#09a144",
  };
  headerValidation: boolean = false;

  spreadsheetObj!: SpreadsheetForeColorComponent;
  error!: string;
  value!: string;
  uploadUsers: Users[] = [];
  uploadUser: Users = emptyUsers();

  saveExcelSample(spreadsheet: SpreadsheetComponent): void {
    const data = spreadsheet.spreadsheetWidget.toJSON();
    this.uploadUsers = [];
    const sheet = data.sheets;
    const rows = sheet![0].rows || [];
    this.error = '';

    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].cells || [];

      if (i === 0) {
        this.headerValidation = this.validateHeader(rows[i]);
        if (!this.headerValidation) {
          this.error = 'Header validation failed.\n';
          break;
        }
        continue;
      }

      while (cells.length < 6) {
        cells.push({ value: '' });
      }

      const isEmptyRow = cells.every(cell => {
        const val = cell?.value?.toString().trim();
        return !val || val === '';
      });

      if (isEmptyRow) continue;

      let filledCount = 0;
      for (let j = 0; j < 6; j++) {
        const val = cells[j]?.value?.toString().trim();
        if (val && val !== '') {
          filledCount++;
        }
      }

      if (filledCount < 6) {
        this.error += `Row ${i}: not all fields have values (fieldcount ${filledCount})\n`;
        continue;
      }

      this.uploadUser = emptyUsers();
      for (let j = 0; j < 6; j++) {
        const rawValue = cells[j]?.value?.toString().trim();
        const value = rawValue && rawValue !== '' ? rawValue : '-';

        if (j === 1) {
          this.uploadUser.firstname = value;
          this.uploadUser.enabled = 'T';
        }
        if (j === 2) {
          this.uploadUser.lastname = value;
        }

        this.validateUpload(value, j);
      }

      this.uploadUsers.push(this.uploadUser);
    }

    const emailSet = new Set<string>();
    for (const user of this.uploadUsers) {
      const email = user.email?.toString().trim().toLowerCase();
      if (!email) continue;

      if (emailSet.has(email)) {
        this.error += `Multiple entries found: ${email}\n`;
      } else {
        emailSet.add(email);
      }
    }

    if (this.error.length > 0) {
      this.errorWindow = true;
      this.title = 'Error(s) - Users Upload';
      this.content = this.error;
    } else {
      const userCount = this.uploadUsers.length;
      const dialog: DialogRef = this.dialogService.open({
        title: 'Confirmation - Users Upload',
        content: `${userCount} Users will be uploaded`,
        actions: [{ text: 'Cancel' }, { text: 'Save' }],
        width: 450,
        height: 200,
        minWidth: 250
      });

      dialog.result.subscribe((result: any) => {
        if (result.text === 'Cancel') {
          dialog.close();
        }
        if (result.text === 'Save') {
          for (const user of this.uploadUsers) {
            user.email = user.email.toLowerCase();
            this.addUser(user);
          }
          this.closeExcelWindow();
        }
      });
    }
  }
  public get formattedErrorText(): string {
    return this.content
      .split('\n')
      .map(line =>
        line
          .split(':')
          .map(part => part.trim())
          .join('\t')
      )
      .join('\n');
  }

  copyToClipboard(): void {
    navigator.clipboard.writeText(this.formattedErrorText).then(() => {
      console.log('Copied to clipboard');
    });
  }

  addUser(userdata: Users) {
    this.portalAdminService.addUsers(userdata).subscribe({
      next: (result) => {
        this.adminUser = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        this.showError(JSON.stringify(error.message));
        this.companiesLoading = false;
      },
      complete: () => {
        this.getAdminUsers();
        this.selection = [];
      }
    });
  }

  validateHeader(value: any): boolean {

    let checkvalue: boolean = true;

    console.log("value",value)

    if (value.cells![0].value!.valueOf().toLocaleString().toUpperCase() != 'EMAIL') {
      checkvalue = false;

    }
    if (value.cells![1].value!.valueOf().toLocaleString().toUpperCase() != 'FIRST NAME') {
      checkvalue = false;
    }
    if (value.cells![2].value!.valueOf().toLocaleString().toUpperCase() != 'LAST NAME') {
      checkvalue = false;
    }
    if (value.cells![3].value!.valueOf().toLocaleString().toUpperCase() != 'USERTYPE') {
      checkvalue = false;
    }
    if (value.cells![4].value!.valueOf().toLocaleString().toUpperCase() != 'COMPANY') {
      checkvalue = false;
    }
    if (value.cells![5].value!.valueOf().toLocaleString().toUpperCase() != 'REMARKS') {
      checkvalue = false;
    }

    if (!checkvalue) {
      this.error = 'Wrong Temoplate Header. must contain [Email,	First Name,	Last Name, Usertype,	Company, Remarks]'
    }
    return checkvalue;
  }

  validateUpload(value: string, field: number) {
    if (field == 0) {

      // Email format validation
      if (!this.emailFormat(value)) {
        this.error += ' Invalid Email Format : ' + value + '\n';
        return;
      }

      const i = this.adminUsers.findIndex((x) => x.email.toUpperCase() === value.toUpperCase());

      if (i != -1) {
        this.error = this.error + ' Email already in Database : ' + value + '\n';

      } else {
        this.uploadUser.email = value;
      }
    }
    if (field == 3) {
      if (!['A', 'S', 'E' ,'X'].includes(value)) {
        this.error = this.error + 'User Type is wrong : ' + value + '\n';
      }
      else {
        this.uploadUser.usertype = value;
      }

    }
    if (field == 4) {
      const i = this.adminCompanies.findIndex((x) => x.companyName === value);

      if (i == -1) {
        this.error = this.error + ' Company not found in Database : ' + value + '\n';

      }
      else {
        this.uploadUser.companyId = this.adminCompanies[i].companyId;
        this.uploadUser.companyName = value;
      }
    }

    if (field == 5) {

      if (value != '-') {
        this.uploadUser.remarks = value;
      }
    }


  }

  onExcelChange(event: SpreadsheetChangeEvent, type: string) {
    console.log(event);
  }

  public onExcelExport(event: SpreadsheetExcelExportEvent): void {
    console.log(`excelExport`);
    console.log(event);
  }

  public onActiveSheetChange(event: SpreadsheetChangeEvent): void {
    console.log(`activeSheetChange`);
    console.log(event);
  }

  public jsonData!: DocumentDescriptor;

  public onSave(spreadsheet: SpreadsheetComponent): void {
    spreadsheet.spreadsheetWidget.saveJSON().then((data) => {
      this.jsonData = data;
      console.log(this.jsonData);
    });
  }
  getFileName() {
    let str = 'Portal Users';
    return `${str} ${this.getFormattedDate()}.xlsx`
  }
  getFormattedDate(): string {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  showAccessDetails(event: any, dataItem: any, rowIndex: number) {

    event.stopPropagation(); // Prevents default row click behavior
    this.selection = [dataItem.email];
    console.log("this.dataItem", event.dataItem);
    this.showWindow = true;
    this.loadingAccessDetails = true; // Start loading

    this.selectedUser = {
      id: dataItem.id,
      firstname: dataItem.firstname,
      lastname: dataItem.lastname,
      email: dataItem.email,
      remarks: dataItem.remarks,
      companyId: dataItem.companyId,
      companyName: dataItem.companyName,
      usertype: dataItem.userType,
      created: dataItem.created,
      createdBy: dataItem.createdBy,
      enabled: dataItem.enabled,
      name: ''
    };

    this.populateUserForm(dataItem);

    console.log("this.selectedUser", this.selectedUser);

    this.portalAdminService.getUserAccessDetails(dataItem.id).subscribe({
      next: (result) => {
        console.log("result", result)
        this.userAccessDetailsList = result;
      },
      error: (error) => {
        this.showError(JSON.stringify(error.message));
      },
      complete: () => {
        this.loadingAccessDetails = false; // Stop loading
        this.cdr.markForCheck();
      }
    });

  }

  closeWindow() {
    this.showWindow = false;
  }


  getOrderList(orderList: PortalAccess): { name: string; access: string }[] {
    return Object.entries(orderList).map(([name, access]) => ({ name, access }));
  }


  expandedPanels: Set<number> = new Set();

  togglePanel(index: number): void {
    if (this.expandedPanels.has(index)) {
      this.expandedPanels.delete(index);
    } else {
      this.expandedPanels.add(index);
    }
  }

  expandAll(): void {
    this.expandedPanels = new Set(this.userAccessDetailsList.map((_, i) => i));
  }

  collapseAll(): void {
    this.expandedPanels.clear();
  }

  exportAll(e: any): void {
    const headerRow = {
      cells: [
        { value: 'ID', background: '#808080', color: '#FFFFFF' },
        { value: 'Email', background: '#808080', color: '#FFFFFF' },
        { value: 'First Name', background: '#808080', color: '#FFFFFF' },
        { value: 'Last Name', background: '#808080', color: '#FFFFFF' },
        { value: 'Company Name', background: '#808080', color: '#FFFFFF' },
      ]
    };
    const dataRows = this.displayUsers.map(item => ({
      cells: [
        { value: item.id },
        { value: item.email },
        { value: item.firstname },
        { value: item.lastname },
        { value: item.companyName }
      ]
    }));

    e.workbook.sheets[0].rows = [headerRow, ...dataRows];
  }

}
